import withAPIAction from 'helpers/withAPIAction'
import {
  SupplierBillListReq,
  CreateSupplierBillReq,
  SupplierBillDetailReq,
  DeleteSupplierBillReq,
} from './types'
import {
  getSupplierBillListAction,
  createSupplierBillAction,
  getSupplierBillDetailAction,
  deleteSupplierBillAction,
} from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'
import { getRequestString } from 'helpers/format'

export const supplierBillListAPI = (data: SupplierBillListReq, token: string, xmid: string) => {
  return withAPIAction<SupplierBillListReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.supplierBillList}?${getRequestString(data)}`,
    data,
    token,
    xmid,
  })(getSupplierBillListAction)
}

export const createSupplierBillAPI = (data: CreateSupplierBillReq, token: string, xmid: string) => {
  return withAPIAction<CreateSupplierBillReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.createSupplierBill,
    data,
    token,
    xmid,
  })(createSupplierBillAction)
}

export const getSupplierBillDetailAPI = (data: SupplierBillDetailReq, token: string, xmid: string) => {
  const endPoint = APIPath.getSupplierBillByID.replace(':id', data.id.toString())
  return withAPIAction<SupplierBillDetailReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(getSupplierBillDetailAction)
}

export const deleteSupplierBillAPI = (data: DeleteSupplierBillReq, token: string, xmid: string) => {
  const endPoint = APIPath.deleteSupplierBill.replace(':id', data.id.toString())
  return withAPIAction<DeleteSupplierBillReq>({
    method: 'DELETE',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(deleteSupplierBillAction)
}
